export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["pending"] = "pending";
    DocumentStatus["rejected"] = "rejected";
    DocumentStatus["approved"] = "approved";
})(DocumentStatus || (DocumentStatus = {}));
